export default "/_next/static/images/texture-1-a3f210dc3adbceeaaed27e4706b8020a.png";